import { Box, Link, Menu, Navbar } from '@lego/klik-ui';
import { matchPath, Link as ReactRouterLink, useLocation } from 'react-router-dom';
import { Issues } from '../ReportIssue';
import { RoleToggle } from '../RoleToggle';

type Props = {
  isOpen: boolean;
  toggleMenu: () => void;
  navItems: readonly {
    path: string;
    label: string;
  }[];
  navEmmaItems: readonly {
    path: string;
    label: string;
    isExternal?: boolean;
  }[];
};

export const MobileNavigationBar = ({ isOpen, toggleMenu, navItems, navEmmaItems }: Props) => {
  const { pathname } = useLocation();
  const isActive = (path: string) => matchPath(path, pathname) !== null;

  return (
    <Menu isOpen={isOpen}>
      <Menu.Button alignSelf="center" as={Link} onClick={toggleMenu} tabIndex={0}>
        <Navbar.Burger display={{ base: 'block', md: 'none' }} />
      </Menu.Button>
      <Menu.List display={{ base: 'block', md: 'none' }}>
        {navItems.map((item) => (
          <Navbar.Item
            as={ReactRouterLink}
            color={isActive(item.path) ? 'blue' : 'none'}
            isActive={isActive(item.path)}
            key={item.path}
            onClick={toggleMenu}
            p={2}
            to={item.path}
          >
            {item.label}
          </Navbar.Item>
        ))}
        <Menu.Divider display={{ base: 'block', md: 'none' }} />
        {navEmmaItems.map((item) => {
          return item.isExternal ? (
            <Navbar.Item
              href={item.path}
              key={item.path}
              onClick={toggleMenu}
              p={2}
              rel="noopener noreferrer"
              target="_blank"
            >
              {item.label}
            </Navbar.Item>
          ) : (
            <Navbar.Item
              as={ReactRouterLink}
              color={isActive(item.path) ? 'blue' : 'none'}
              isActive={isActive(item.path)}
              key={item.path}
              onClick={toggleMenu}
              p={2}
              to={item.path}
            >
              {item.label}
            </Navbar.Item>
          );
        })}
        <Menu.Divider display={{ base: 'block', md: 'none' }} />
        <Box display={{ base: 'block', md: 'none' }}>
          {Object.values(Issues).map((issue) => (
            <Navbar.Item
              href={issue.link}
              key={issue.label}
              onClick={toggleMenu}
              p={2}
              target="_blank"
            >
              {issue.label}
            </Navbar.Item>
          ))}
        </Box>
        <RoleToggle onRoleChanged={toggleMenu} />
      </Menu.List>
    </Menu>
  );
};
